import { render, staticRenderFns } from "./TierCard.vue?vue&type=template&id=51bd0e76&scoped=true&"
import script from "./TierCard.vue?vue&type=script&lang=ts&"
export * from "./TierCard.vue?vue&type=script&lang=ts&"
import style0 from "./TierCard.vue?vue&type=style&index=0&id=51bd0e76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd0e76",
  null
  
)

export default component.exports